import { render } from "./AsignarChatModal.vue?vue&type=template&id=797f41ac"
import script from "./AsignarChatModal.vue?vue&type=script&lang=js"
export * from "./AsignarChatModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__